/* eslint-disable */
const getChangePaymentData = (key) =>
  axios.get(`${"/axios/routes?" + "key="}${key}`);

// checkout address object used for address validation
const changePaymentAddressObject = async () => {
  const { user_id } = (await getChangePaymentData("user_id")).data;
  const address_object = {
    billing_address: {
      id: $('input[name="billing_address_id"]:checked').val(),
      addressable_id: user_id,
      addressable_type: 'App\\Models\\User',
      company: $("#billing_company").val(),
      first_name: $("#billing_first_name").val(),
      last_name: $("#billing_last_name").val(),
      line_1: $("#billing_line_1").val(),
      line_2: $("#billing_line_2").val(),
      city: $("#billing_city").val(),
      county: $("#billing_county").val(),
      state: $("#billing_state").val(),
      zip: $("#billing_zip").val(),
      country: $("#billing_country").val(),
      validation_type: $('input[name=validation_type]').val(),
      validated_address: $('input[name=validated_address]').val(),
    },
  };
  return address_object;
};

const validateBilling = async () => {
  const { validate_billing_route } = (
    await getChangePaymentData("validate_billing_route")
  ).data;
  return await axios({
    method: "post",
    url: validate_billing_route,
    data: await changePaymentAddressObject(),
  })
    .then(async function (response) {
      return response;
    })
    .catch(function (error) {
      const errorObject = error.response.data.errors;
      const errorString = Object.values(errorObject).join(" ");
      throw new Error(`Address Validation Error - ${errorString}`);
    });
};

// Call to stripe api to create a source from customer entered cc data and billing address
const createSourceChangePayment = async (address_info) => {
  const { currency } = (await getChangePaymentData("currency")).data;
  return await stripe
    .createSource(card, {
      type: "card",
      currency: await currency,
      owner: {
        name: `${address_info.first_name} ${address_info.last_name}`,
        address: {
          line1: address_info.address,
          line2: address_info.address2,
          city: address_info.city,
          state: address_info.state,
          country: address_info.country,
          postal_code: address_info.zip,
        },
      },
      usage: "reusable",
    })
    .then(function (response) {
      if (response.error) {
        throw new Error(`Stripe - ${response.error.message}`);
      }
      return {
        response: response.source,
        billing_id: address_info.id,
      };
    });
};

// Create new customer Card from source data returned from stripe api call
const createCreditCardChangePayment = async (source) => {
  const { create_customer_card_route } = (
    await getChangePaymentData("create_customer_card_route")
  ).data;
  return await axios({
    method: "post",
    url: create_customer_card_route,
    data: {
      source_id: source.response.id,
      billing_id: source.billing_id,
    },
  })
    .then(async function (response) {
      return response;
    })
    .catch(function (error) {
      throw new Error(`Credit Card - ${error.message}`);
    });
};

// attach card data to the checkout submit form
const attachCCChangePayments = (card) => {
  // vars
  const opt = document.createElement("option");
  const text = document.createTextNode(
    `${card.card_type} - ${card.masked_number.substr(
      card.masked_number.length - 4
    )}`
  );

  // append new option to the credit_card select
  opt.appendChild(text);
  opt.value = card.id;
  opt.selected = true;
  $("#credit_card").append(opt);
};

const toggleChangePaymentButtons = (disabled = true) => {
  $(".checkout-btn").each(function (i, element) {
    element.disabled = disabled;
  });
};

// hide all tabs, shows given tab name
// types 'bank_acct' | 'credit_card' | 'ach_credit' | 'wallet' | 'order_submit' | 'new_cc | 'address' | 'payment_methods'
window.hideTabsChangePayment = (show = "") => {
  const tabs = $(".payment-method-tab");
  tabs.each(function () {
    if (show !== "" && $(this).attr("id") === `tab_${show}`) {
      $(this).show();
    } else {
      $(this).hide();
    }
  });
};

window.changePaymentMethod = async (checkout_method) => {
  try {
    $("#change_payment_modal").modal("hide");
    toggleChangePaymentButtons(true);
    swal.fire({ title: "Processing..." });
    swal.showLoading();
    await attachChangePaymentData(checkout_method);
    $("#change_payment_method").submit();
  } catch (e) {
    displayChangePaymentError(e.message);
    toggleChangePaymentButtons(false);
    $("#change_payment_modal").modal("show");
  }
};

window.newCreditCardChangePayment = async () => {
  try {
    $("#change_payment_modal").modal("hide");
    toggleChangePaymentButtons(true);
    swal.fire({ title: "Validating Address..." });
    swal.showLoading();
    const address_data = await validateBilling();
    swal.getTitle().textContent = "Creating Card...";
    const stripeSource = await createSourceChangePayment(
      address_data.data.billing_address
    );
    const card = await createCreditCardChangePayment(stripeSource);
    swal.getTitle().textContent = "Processing...";
    await attachCCChangePayments(card.data.card);
    await attachChangePaymentData("credit_card");
    await $("#change_payment_method").submit();
  } catch (e) {
    displayChangePaymentError(e.message);
    toggleChangePaymentButtons(false);
    $("#change_payment_modal").modal("show");
  }
};

window.addressNext = async () => {
  try {
    $("#change_payment_modal").modal("hide");
    toggleChangePaymentButtons(true);
    swal.fire({ title: "Validating Address..." });
    swal.showLoading();
    const address_data = await validateBilling();
    const form = $("#change_payment_method");

    if (address_data.data.billing_address.id === null) {
      throw new Error("Address data is missing!");
    }

    $("#change_payment_method #billing_address_id").remove();
    form.append(
      $(
        '<input type="hidden" id="billing_address_id" name="billing_address_id" />'
      ).val(await address_data.data.billing_address.id)
    );

    await hideTabsChangePayment("payment_methods");
    swal.close();
    $("#change_payment_modal").modal("show");
    toggleChangePaymentButtons(false);
  } catch (e) {
    displayChangePaymentError(e.message);
    toggleChangePaymentButtons(false);
    $("#change_payment_modal").modal("show");
  }
};

const displayChangePaymentError = async (message) => {
  swal.getTitle().textContent = message;
  swal.hideLoading();
};

const attachChangePaymentData = (checkout_method) => {
  const card_id = $(`#${checkout_method}`).val();
  const form = $("#change_payment_method");
  // attach
  form.append(
    $(
      '<input type="hidden" id="checkout_method" name="checkout_method" />'
    ).val(checkout_method)
  );
  form.append(
    $('<input type="hidden" id="card_id" name="card_id" />').val(card_id)
  );
};
